import Parse from "parse";
import React, { useMemo, useState, useEffect } from "react";
import { useTable } from "react-table";
import "./EventsTable.css";
import { useNavigate } from "react-router-dom";
import DeleteEventDialogComponent from "../DeleteEventDialogComponent";
import { Box, Button as Button2, Text } from "@chakra-ui/react";
import moment from "moment-with-locales-es6";
import "antd/dist/antd.css";
import { Table, Input, Button, Space, Checkbox, Dropdown } from "antd";
import Highlighter from "react-highlight-words";
import { DownOutlined, SearchOutlined, UserOutlined } from "@ant-design/icons";

export default function EventsTable({ searchedValue }) {
  const navigate = useNavigate();

  const [data2, setData] = useState([]);
  const [pos, setPos] = useState(2);

  async function fetchEvent() {
    const Event = Parse.Object.extend("Annonce");
    const query = new Parse.Query(Event);
    query.equalTo("type", "event").equalTo("userId", Parse.User.current());
    const event = await query.find();

    const tempData = [];
    for (let i = 0; i < event.length; i++) {
      let t = moment(event[i].get("dateDebut"))
        .locale("fr")
        .format("dddd lll")
        .toString();
      let x =
        t.slice(0, t.length - 5) +
        "de " +
        t.slice(t.length - 5) +
        " à " +
        moment(event[i].get("dateFin")).locale("fr").format("LT").toString();
      tempData.push({
        id: event[i].id,
        key: i,
        name: event[i].get("titre"),
        date: x,
        sdate: event[i].get("dateDebut"),
        inscrits:
          event[i].get("nbInscrit") + "/" + event[i].get("nbInscritMax"),
        type: event[i].get("typeContrat"),
        virtuel: event[i].get("virtuel"),
        inscrit: event[i].get("nbInscrit"),
      });
    }
    console.log(tempData.length);
    setData(tempData);
    return event;
  }

  async function deleteEvent(id) {
    const Event = Parse.Object.extend("Annonce");
    const query = new Parse.Query(Event);
    query.equalTo("objectId", id);
    const destroyEvent = await query.first();

    destroyEvent.destroy().then(
      (myObject) => {
        fetchEvent();
      },
      (error) => {}
    );
  }

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      fetchEvent();
    }
  }, []);

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      setPos(searchedValue);
      handleSearch2(searchedValue, "name");
    }
  }, [searchedValue]);

  const [searchText, setSearchText] = useState();
  const [searchedColumn, setSearchedColumn] = useState();

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
          >
            Chercher
          </Button>
          <Button onClick={() => handleReset(clearFilters)} size="small">
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleSearch2 = (selectedKeys, dataIndex) => {
    setSearchText(selectedKeys);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const columns2 = [
    {
      title: "Nom de l’événement",
      dataIndex: "name",
      key: "name",
      width: "15%",
      fixed: "left",
      ...getColumnSearchProps("name"),
      render: (record, row) => {
        console.log(record);
        return <Text noOfLines={1}>{record}</Text>;
      },
    },
    {
      responsive: ["md"],
      title: "Type d’événement",
      dataIndex: "type",
      key: "type",
      width: "  5%",
      sorter: function (a, b) {
        if (b.type < a.tytpe) return -1;
        else return 1;
      },
      sortDirections: ["descend", "ascend"],
    },
    {
      responsive: ["md"],
      title: "Date de l’événement",
      dataIndex: "date",
      key: "date",
      width: "15%",
      sorter: (a, b) => new Date(b.sdate) - new Date(a.sdate),
      sortDirections: ["descend", "ascend"],
    },
    {
      responsive: ["md"],
      title: "Inscrits",
      dataIndex: "inscrits",
      key: "inscrits",
      width: "5%",
      sorter: function (a, b) {
        if (b.inscrits < a.inscrits) return -1;
        else return 1;
      },
      sortDirections: ["descend", "ascend"],
    },
    {
      responsive: ["md"],
      title: "Virtuel",
      dataIndex: "virtuel",
      key: "virtuel",
      width: "5%",
      render: (record, row) => (
        <div className="btn-row">
          {console.log(row)}
          {
            row.virtuel
              ? "oui"
              : // <Checkbox checked="Check" disabled="disabled" />
                "non"
            // <Checkbox disabled />
          }
        </div>
      ),
    },
    {
      responsive: ["xs"],
      title: "Actions",
      dataIndex: "type",
      key: "candidats",
      width: "10%",
      render: (record, row) => {
        const items = [
          {
            label: (
              <Button2
                borderRadius={"full"}
                paddingInline={4}
                w={"100%"}
                backgroundColor="#0080FF"
                color="white"
                onClick={() => {
                  navigate(`/AfficherEvents/${row.id.replace("afficher", "")}`);
                }}
              >
                Afficher
              </Button2>
            ),
            key: row.id + "afficher",
            onClick: (id) => {
              navigate(`/AfficherEvents/${id.key.replace("afficher", "")}`);
            },
          },
          {
            label:
              row.sdate > new Date() ? (
                <Button2
                  borderRadius={"full"}
                  paddingInline={4}
                  w={"100%"}
                  backgroundColor="#FF9900"
                  color="white"
                  onClick={() => {
                    navigate(`/EditerEvents/${row.id.replace("editer", "")}`);
                  }}
                >
                  Editer
                </Button2>
              ) : (
                <Button2
                  borderRadius={"full"}
                  paddingInline={4}
                  w={"100%"}
                  backgroundColor="#FF9900"
                  color="white"
                  disabled
                  onClick={() => {
                    navigate(`/EditerEvents/${row.id.replace("editer", "")}`);
                  }}
                >
                  Editer
                </Button2>
              ),
            key: row.id + "editer",
            onClick: (id) => {
              navigate(`/EditerEvents/${id.key.replace("editer", "")}`);
            },
          },
          {
            label: (
              <DeleteEventDialogComponent
                id={row.id.replace("supprimer", "")}
                title={row.name}
                deleteEvent={deleteEvent}
              />
            ),
            key: row.id + "supprimer",
          },
        ];

        const menuProps = {
          items,
        };

        return (
          <Dropdown menu={menuProps}>
            <Button2 borderRadius={20} bg={"white"}>
              <Space>
                Actions
                <DownOutlined />
              </Space>
            </Button2>
          </Dropdown>
        );
      },
    },
    {
      responsive: ["md"],
      title: "Actions",
      dataIndex: "date",
      width: "30%",
      key: "date",
      render: (record, row) => (
        <div className="btn-row">
          {console.log(row)}
          {console.log(new Date())}
          {console.log(row.sdate < new Date())}
          <Button2
            borderRadius={"full"}
            paddingInline={4}
            w={"31%"}
            backgroundColor="#0080FF"
            color="white"
            onClick={() => {
              navigate(`/AfficherEvents/${row.id}`);
            }}
          >
            Afficher
          </Button2>
          {row.sdate > new Date() ? (
            <Button2
              borderRadius={"full"}
              paddingInline={4}
              w={"31%"}
              backgroundColor="#FF9900"
              color="white"
              onClick={() => {
                navigate(`/EditerEvents/${row.id}`);
              }}
            >
              Editer
            </Button2>
          ) : (
            <Button2
              borderRadius={"full"}
              paddingInline={4}
              w={"31%"}
              backgroundColor="#FF9900"
              color="white"
              onClick={() => {
                navigate(`/EditerEvents/${row.id}`);
              }}
            >
              Editer
            </Button2>
          )}
          <DeleteEventDialogComponent
            id={row.id}
            title={row.name}
            deleteEvent={deleteEvent}
          ></DeleteEventDialogComponent>
        </div>
      ),
    },
  ];

  return (
    <Table
      columns={columns2}
      pagination={{ simple: true, pageSize: 5, hideOnSinglePage: true }}
      // dataSource={data2.slice(5 * (pos -1), 5 * pos)}
      dataSource={data2}
    />
  );
}
